import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export const SimpleModal = ({ title, onClose, children, testId, dark = false, maxWidth = 480 }) => {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div onClick={(e) => e.stopPropagation()} data-testid={testId} role="dialog" aria-modal="true"
        style={{ background: dark ? '#1f2937' : 'white', color: dark ? '#f3f4f6' : '#1f2937', borderRadius: 14, padding: '1.5rem', width: '100%', maxWidth, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', gap: '1rem' }}>
          <h3 style={{ fontWeight: 700, fontSize: '1.1rem', margin: 0 }}>{title}</h3>
          <button type="button" onClick={onClose} data-testid={`${testId}-close`} aria-label="Fechar"
            style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'inherit', padding: 4 }}>
            <X className="w-5 h-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const errorText = (err, fallback) => (typeof err?.response?.data?.detail === 'string' ? err.response.data.detail : fallback);
